import { defineComponent as _defineComponent } from 'vue'
import InputSearch from "@/components/ui/input/InputSearch.vue";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import { debounce } from "@/helpers/debounce";
  import { formatPrice } from "@/helpers/transformation/price";
  import router from "@/router";
  import { CustomerId } from "@/types/CustomerDetails";
  import { LeadId } from "@/types/LeadInterface";
  import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";

  type WaitlistItem = {
    customerId?: CustomerId;
    leadId?: LeadId;
    lotSize?: {
      from?: number;
      to?: number;
    };
    frontage?: {
      from?: number;
      to?: number;
    };
    budget?: {
      from?: number;
      to?: number;
    };
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'WaitlistView',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const toast = useToast();

  const waitlist = ref<WaitlistItem[]>([]);
  const searchQuery = ref("");
  const debounceSearch = debounce(getSubscription);
  const isWaitlistEnabled = ref(true);
  const togglingWaitlist = ref(false);

  const getContactsQuantity = computed(() => {
    return waitlist.value.filter((item) => item.customerId).length;
  });

  const getLeadsQuantity = computed(() => {
    return waitlist.value.filter((item) => item.leadId).length;
  });

  onMounted(() => {
    getSubscription();
    fetchWaitlistStatus();
  });

  const loading = ref(false);

  function getSubscription() {
    if (estateId.value) {
      loading.value = true;
      store
        .dispatch("subscription/getSubscription", {
          estateId: estateId.value,
          searchKey: searchQuery.value,
        })
        .then((res) => {
          waitlist.value = res.data;
        })
        .finally(() => {
          loading.value = false;
        });
    }
  }
  function fetchWaitlistStatus() {
    if (estateId.value) {
      store.dispatch("estate/getEstate", estateId.value).then((res) => {
        isWaitlistEnabled.value = res.data.isWaitlistEnabled !== false;
      });
    }
  }
  function toggleWaitlist() {
    if (!estateId.value) return;

    togglingWaitlist.value = true;
    const newValue = !isWaitlistEnabled.value;

    store
      .dispatch("estate/updateEstate", {
        id: estateId.value,
        data: { isWaitlistEnabled: newValue },
      })
      .then(() => {
        isWaitlistEnabled.value = newValue;
      })
      .finally(() => {
        togglingWaitlist.value = false;
      });
  }
  function toggleWaitlistIfReady() {
    if (togglingWaitlist.value) return;

    toggleWaitlist();
  }
  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  watch(
    () => estateId.value,
    () => {
      getSubscription();
      fetchWaitlistStatus();
    }
  );
  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

  const onRow = (data: { id: string; route: string }) => {
    router.push(`/${data.route}/${data.id}`);
  };

  const isExportingWaitlist = ref(false);

  function exportWaitlist() {
    if (!estateId.value) return;

    isExportingWaitlist.value = true;
    store
      .dispatch("contact/exportLeads", {
        estateId: estateId.value,
        params: { source: "Waitlist" },
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = `waitlist-export-${
          new Date().toISOString().split("T")[0]
        }.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        toast.error("Failed to export waitlist");
      })
      .finally(() => {
        isExportingWaitlist.value = false;
      });
  }

  const getFullName = (item: CustomerId | LeadId) => {
    return `${item?.firstName} ${item?.lastName}`;
  };

  const getPostcode = (item: CustomerId | LeadId) => {
    if (item?.postcode) {
      return item?.postcode;
    } else if (item?.state) {
      return item?.state;
    }

    return "-";
  };

  const handleRowClick = (item: WaitlistItem) => {
    if (item.customerId) {
      onRow({ id: item.customerId._id, route: "contacts" });
    } else if (item.leadId) {
      onRow({ id: item.leadId._id, route: "leads" });
    }
  };

const __returned__ = { store, toast, waitlist, searchQuery, debounceSearch, isWaitlistEnabled, togglingWaitlist, getContactsQuantity, getLeadsQuantity, loading, getSubscription, fetchWaitlistStatus, toggleWaitlist, toggleWaitlistIfReady, estateId, onRow, isExportingWaitlist, exportWaitlist, getFullName, getPostcode, handleRowClick, InputSearch, ToggleButton, get debounce() { return debounce }, get formatPrice() { return formatPrice }, get router() { return router }, get CustomerId() { return CustomerId }, get LeadId() { return LeadId }, ref, onMounted, computed, watch, get useStore() { return useStore }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})